import Cookies from "js-cookie";
import { ATL_COHORT } from "src/analytics/atl-analytics/cohort";

import FeatureGates, {
    FeatureGateEnvironment,
    FromValuesClientOptions
} from "@atlassian/feature-gate-js-client";
import {
    CustomAttributes,
    Identifiers
} from "@atlassian/feature-gate-node-client-bootstrapper";

import {
    ANALYTICS_ANONYMOUS_ID_COOKIE,
    ATLASSIAN_ACCOUNT_ID_COOKIE,
    getCustomAttributes
} from "./bootstrapper";
import { FeatureGatesBootstrapValues } from "./types";
export const TARGET_APP = "bxp-web-platform_web";

const getEnvironment = (): FeatureGateEnvironment => {
    switch (process.env["CLIENT_LIBRARY_ENV"]) {
        case "production":
            return FeatureGateEnvironment.Production;
        case "staging":
            return FeatureGateEnvironment.Staging;
        case "development":
        default:
            return FeatureGateEnvironment.Staging;
    }
};

export const initializeFeatureGatesClient = async (
    bootstrapValues: FeatureGatesBootstrapValues,
    options: Omit<
        FromValuesClientOptions,
        "environment" | "targetApp" | "sdkKey"
    > = {}
) => {
    const isStatic = typeof window !== "undefined" && window.IS_STATIC;
    if (!isStatic) {
        await FeatureGates.initializeFromValues(
            {
                ...options,
                environment: getEnvironment(),
                targetApp: TARGET_APP,
                sdkKey: bootstrapValues.clientSdkKey,
                eventLoggingApi: "https://xp.atlassian.com/v1/"
            },
            bootstrapValues.identifiers,
            bootstrapValues.customAttributes as CustomAttributes,
            bootstrapValues.experimentValues
        );
    } else {
        /**
         * Client side initialization of FeatureGates.
         * On the browser, get values from cookies as request headers are not available
         * */

        const identifiers: Identifiers = {
            analyticsAnonymousId: JSON.parse(
                decodeURIComponent(
                    Cookies.get(ANALYTICS_ANONYMOUS_ID_COOKIE) ||
                        `"${bootstrapValues.identifiers.analyticsAnonymousId}"`
                )
            ),
            atlassianAccountId: Cookies.get(ATLASSIAN_ACCOUNT_ID_COOKIE)
        };
        const customAttributes = getCustomAttributes({
            headers: {
                "user-agent": window.navigator.userAgent,
                "cookieOverride": JSON.stringify({
                    [ATL_COHORT]: Cookies.get(ATL_COHORT),
                    "cloud.session.token": Cookies.get("cloud.session.token"),
                    "cloud.session.token.stg": Cookies.get(
                        "cloud.session.token.stg"
                    )
                })
            }
        });
        await FeatureGates.initialize(
            {
                ...options,
                environment: getEnvironment(),
                targetApp: TARGET_APP,
                apiKey: process.env["FEATURE_GATES_KEY"] as string,
                eventLoggingApi: "https://xp.atlassian.com/v1/"
            },
            identifiers,
            customAttributes
        );
    }
};
